import { createContext } from "react"
import { InvoiceSummaryWithCustomerJobData } from "../../../domain/invoicing/invoice"

export type InvoiceActionModalType = 'sendInvoice' | 'payInvoice' | 'exportToQb' | 'delete' | 'viewInvoice' | 'emailReminder'

export type ActiveModal = {
  type: InvoiceActionModalType
  invoiceSummary: InvoiceSummaryWithCustomerJobData
}

export type InvoiceActionsContextData = {
  activeModal: ActiveModal | null
  openModal: (type: InvoiceActionModalType, invoiceSummary: InvoiceSummaryWithCustomerJobData) => void
  closeModal: () => void
}

const InvoiceActionsContext = createContext<InvoiceActionsContextData>({
  activeModal: null,
  openModal: () => { },
  closeModal: () => { }
})

export default InvoiceActionsContext
